/* Routing */
import {useParams} from "react-router-dom";
/* Contexts */
import useDeceased from "../../hooks/useDeceased";
import { categories } from "../../data/buttonActions";
/* Components */
import ActionsBox from "../../components/ActionsBox";
import DeceasedDetails from "../../components/common/DeceasedDetails";
import Header from "../../components/common/Header";
import Icon from "../../components/common/Icon";
import {
    getCompletionStatus,
    getDeceasedAdministrator, getDeceasedCorrespondent,
    getDeceasedInfos,
    getDeceasedPartner
} from "../../api/pro/deceasedReq";
import useAuth from "../../hooks/useAuth";
import {useEffect, useState} from "react";
import Missing from "../Missing";
import {capitalize} from "../../helper/tools";
import gestionDefunt from "../../img/v2_i_gestionDefunt.png";
import listeDefunts from "../../img/v2_i_listeDefunts.png";
import solutionsMultiServices from "../../img/v2_i_solutionsMultiServices.png";
import ViewDeceasedMainInfos from "./visualisation pages/ViewDeceasedMainInfos";
import ViewDeceasedSolutions from "./visualisation pages/ViewDeceasedSolutions";


export default function ManageDeceased() {
    const { id } = useParams();
    const {
        deceasedInfos, setDeceasedInfos, setLastDeceased, adminInfos, setAdminInfos, partnerInfos, setPartnerInfos, correspondentInfos, setCorrespondentInfos
    } = useDeceased();
    const { auth } = useAuth();
    const token = auth.token;
    const [ completionStatus, setCompletionStatus ] = useState();
    const [ currentDeceasedId, setCurrentDeceasedId ] = useState(null);
    const sourceSolutions = [solutionsMultiServices];
    const sourcesManage = [listeDefunts];

    const apiDeceasedInfos = async () => {
        const response = await getDeceasedInfos(token, id)
        setDeceasedInfos(response)
    };

    const apiPartnerInfos = async () => {
        const response = await getDeceasedPartner(token, id)
        setPartnerInfos(response)
    }

    const apiAdminInfos = async () => {
        const response = await getDeceasedAdministrator(token, id)
        setAdminInfos(response)
    }

    const apiCorrespondentInfos = async () => {
        const response = await getDeceasedCorrespondent(token, id)
        setCorrespondentInfos(response)
    }

    const apiGetCompletionStatus = async () => {
        const response = await getCompletionStatus(token, id)
        setCompletionStatus(response)
    }

    useEffect(() => {
        const deceasedId = parseInt(id, 10);
        
        if (deceasedId && deceasedId !== 0) {
            // Si l'ID a changé, réinitialiser tous les states
            if (currentDeceasedId !== deceasedId) {
                setCurrentDeceasedId(deceasedId);
                setAdminInfos(null);
                setPartnerInfos(null);
                setCorrespondentInfos(null);
                setCompletionStatus(null);
            }
            
            // Recharger les infos du défunt si nécessaire
            if (!deceasedInfos || Number(deceasedInfos?.id) !== deceasedId) {
                apiDeceasedInfos();
            }
            
            // Recharger les infos du gestionnaire
            if (!adminInfos) {
                apiAdminInfos();
            }
            
            // Recharger les infos du partenaire
            if (!partnerInfos) {
                apiPartnerInfos();
            }
            
            // Recharger les infos du correspondant
            if (!correspondentInfos) {
                apiCorrespondentInfos();
            }
        }
    }, [ id, currentDeceasedId, deceasedInfos, adminInfos, partnerInfos, correspondentInfos ]);

    useEffect(() => {
        setLastDeceased(`${capitalize(deceasedInfos?.lastName)} ${capitalize(deceasedInfos?.firstName)}`)
    }, [ deceasedInfos ]);

    useEffect(() => {
        if (id && !completionStatus) {
            apiGetCompletionStatus()
        }
    }, [ id, completionStatus ]);

    return (
        <main>
            { deceasedInfos?.error &&
                <Missing />
            }
            { !deceasedInfos?.error &&
                <>
                    <Header
                        location="Espace de gestion du défunt"
                        parent="Tableau de bord"
                        slug="/"
                    />
                    <div id="gestion-defunt" className="content-container">
                        <Icon
                            source={ sourcesManage }
                            span="Gestion du défunt"
                        />
                        <ViewDeceasedMainInfos apiDeceasedInfos={apiDeceasedInfos} deceasedInfos={deceasedInfos} partnerInfos={partnerInfos} adminInfos={adminInfos} correspondentInfos={correspondentInfos} />
                    </div>
                    <div id="solutions" className="content-container">
                        <Icon className="solutions-icon"
                            source={ sourceSolutions }
                            span="Solutions multi-services"
                        />
                        <ViewDeceasedSolutions deceasedInfos={deceasedInfos} />
                    </div>
                </>
            }
        </main>
    )
}